<template>
  <van-tabbar v-model="active" :route="true" :placeholder="true" active-color="#1C54CF" inactive-color="#D2D4D9">
    <van-tabbar-item replace to="/demo" icon="shouye">
      首页
    </van-tabbar-item>
    <van-tabbar-item replace to="/demo/jobList" icon="zhiyeweisheng1">
      职位
    </van-tabbar-item>
    <van-tabbar-item replace to="/demo/companyList" icon="qiye">
      企业
    </van-tabbar-item>
    <van-tabbar-item replace to="/demo/my" icon="wode">
      我的
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>

export default {
  name: 'navbar',
  data() {
    return {
      active: 0,
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/.van-tabbar-item__icon .van-icon{
    font-size: .6rem;
  }
  /deep/.van-tabbar{
    box-shadow: 0 0 16px rgba(0,0,12,.06);
    padding-top: 4px;
  }
  /deep/.van-tabbar-item__text{
    font-size: 12px;
  }
</style>
